import {useRenameUserScheduleApi} from "../../../../../react-query-hooks/schedule";
import {RenameUserScheduleFormValues} from "../components/rename-schedule-form/schema-validation";
import {renameUserScheduleDto} from "../rename-user-schedule-service";

interface RenameUserScheduleHookResult {
  renameUserSchedule(values: RenameUserScheduleFormValues): void;
  wasUserScheduleRenamed: boolean;
  isRenamingUserSchedule: boolean;
  responseData?: {};
}

export function useRenameUserScheduleHook({
  closeModal,
}: {
  closeModal(): void;
}): RenameUserScheduleHookResult {
  const renameUserScheduleMutation = useRenameUserScheduleApi();

  const renameUserSchedule = (values: RenameUserScheduleFormValues) => {
    renameUserScheduleMutation.mutate(renameUserScheduleDto(values), {
      onSuccess(data) {
        closeModal();
      },
    });
  };
  return {
    renameUserSchedule,
    wasUserScheduleRenamed: renameUserScheduleMutation.isSuccess,
    isRenamingUserSchedule: renameUserScheduleMutation.isLoading,
    responseData: renameUserScheduleMutation.isSuccess
      ? renameUserScheduleMutation.data.data
      : undefined,
  };
}
